/* eslint-disable @typescript-eslint/no-explicit-any */
import videojs from "video.js";

let registered = false;

/** Register once: −10s / +10s seek buttons for Video.js control bar. */
export function registerVideoJsSkipSeekButtons(): void {
  if (registered) return;
  registered = true;

  const Button = videojs.getComponent("Button") as any;

  class SkipBack10 extends Button {
    constructor(player: any, options?: any) {
      super(player, options);
      this.controlText("تأخير 10 ثوانٍ");
    }

    handleClick() {
      const p = this.player();
      p.currentTime(Math.max(0, p.currentTime() - 10));
    }

    buildCSSClass() {
      return `vjs-skip-rewind-10 ${super.buildCSSClass()}`;
    }
  }

  class SkipForward10 extends Button {
    constructor(player: any, options?: any) {
      super(player, options);
      this.controlText("تقديم 10 ثوانٍ");
    }

    handleClick() {
      const p = this.player();
      const d = p.duration();
      const next = p.currentTime() + 10;
      if (typeof d === "number" && Number.isFinite(d) && d > 0) {
        p.currentTime(Math.min(d, next));
      } else {
        p.currentTime(next);
      }
    }

    buildCSSClass() {
      return `vjs-skip-forward-10 ${super.buildCSSClass()}`;
    }
  }

  (videojs as { registerComponent: (n: string, c: unknown) => void }).registerComponent(
    "SkipBack10",
    SkipBack10
  );
  (videojs as { registerComponent: (n: string, c: unknown) => void }).registerComponent(
    "SkipForward10",
    SkipForward10
  );
}

/** Insert skip buttons after play; safe to call multiple times (e.g. after responsive relayout). */
export function ensureSkipSeekButtonsInControlBar(player: any): void {
  const cb = player?.controlBar;
  if (!cb) return;

  const playToggle = cb.getChild("playToggle");
  const playIndex = playToggle ? cb.children().indexOf(playToggle) : -1;
  const insertAt = playIndex >= 0 ? playIndex + 1 : 0;

  if (!cb.getChild("SkipBack10")) {
    cb.addChild("SkipBack10", {}, insertAt);
  }
  if (!cb.getChild("SkipForward10")) {
    const back = cb.getChild("SkipBack10");
    const fwdIndex = back ? cb.children().indexOf(back) + 1 : insertAt + 1;
    cb.addChild("SkipForward10", {}, fwdIndex);
  }
}

export function addSkipSeekButtonsToControlBar(player: any): void {
  const run = () => ensureSkipSeekButtonsInControlBar(player);

  player.ready(() => {
    run();
    requestAnimationFrame(run);
  });

  player.on("playerresize", run);
}
